import React, { FC } from 'react';
import { Tag } from 'antd';
import { nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import {
	BUYER_ADMIN,
	BUYER_STORE_ASSOCIATE,
	BUYER_USER,
	ROLES,
	SUPER_ADMIN,
	SUPPLIER_ACCOUNTING_MANAGER,
	SUPPLIER_ADMIN,
	SUPPLIER_INVENTORY_MANAGER,
	SUPPLIER_MANAGER,
	SUPPLIER_TECH,
	SUPPLIER_USER,
} from '../roles/roles';

// Per-role colour scheme. antd's preset Tag colours are used rather than hand-picked hexes so
// each pill gets a matching light background, text and border straight from the design system.
// Admin takes purple to echo the buyer brand colour.
const ROLE_TAG_COLORS = {
	[SUPER_ADMIN]: 'magenta',
	// Buyer roles — Admin takes purple to echo the buyer brand colour.
	[BUYER_ADMIN]: 'purple',
	[BUYER_USER]: 'blue',
	[BUYER_STORE_ASSOCIATE]: 'cyan',
	// Supplier roles — Admin takes cyan to echo the supplier brand colour.
	[SUPPLIER_ADMIN]: 'cyan',
	[SUPPLIER_MANAGER]: 'blue',
	[SUPPLIER_TECH]: 'green',
	[SUPPLIER_USER]: 'geekblue',
	[SUPPLIER_INVENTORY_MANAGER]: 'gold',
	[SUPPLIER_ACCOUNTING_MANAGER]: 'volcano',
};

// One coloured pill per role. `role` is a list on the facility-users payload, and a user can
// legitimately hold more than one, so render them all rather than silently showing the first.
// Shared by the member picker dropdown and the group detail table so both stay in step.
export const UserRoleTags: FC<{ roles: string[] }> = ({ roles }) => (
	<span className="flex flex-shrink-0 items-center gap-1">
		{(roles || []).map((role) => (
			<Tag
				key={role}
				color={nullSafeGetOrElse(role, ROLE_TAG_COLORS, 'default')}
				className="footnoteregular m-0"
			>
				{nullSafeGetOrElse(`${role}.displayName`, ROLES, role)}
			</Tag>
		))}
	</span>
);

export default UserRoleTags;
